import styled from "styled-components";

const ItemEndContainer = styled.div`
	margin-left: 8px;
	font-weight: var(--item-end-font-weight);
`;

export default ItemEndContainer;
